import api from './api';
import {
  Endorsement,
  EndorsementCreate,
  EndorsementUpdate,
  EndorsementPublic,
  EndorsementWithProviders,
  EndorsementStatistics,
} from '../types/endorsement';
import { ProviderPublic } from '../types/provider';

export const endorsementsApi = {
  // Create a new endorsement
  create: async (data: EndorsementCreate): Promise<Endorsement> => {
    const response = await api.post('/api/endorsements/', data);
    return response.data;
  },

  // Get endorsements received by the current user
  getReceived: async (skip = 0, limit = 100): Promise<EndorsementPublic[]> => {
    const response = await api.get('/api/endorsements/received', {
      params: { skip, limit },
    });
    return response.data;
  },

  // Get endorsements sent by the current user
  getSent: async (skip = 0, limit = 100): Promise<EndorsementWithProviders[]> => {
    const response = await api.get('/api/endorsements/sent', {
      params: { skip, limit },
    });
    return response.data;
  },

  // Get pending endorsements for the current user
  getPending: async (skip = 0, limit = 100): Promise<EndorsementPublic[]> => {
    const response = await api.get('/api/endorsements/pending', {
      params: { skip, limit },
    });
    return response.data;
  },

  // Get endorsement statistics for the current user
  getStatistics: async (): Promise<EndorsementStatistics> => {
    const response = await api.get('/api/endorsements/stats');
    return response.data;
  },

  // Get public endorsements for a specific provider
  getProviderEndorsements: async (
    providerId: number,
    skip = 0,
    limit = 100
  ): Promise<EndorsementPublic[]> => {
    const response = await api.get(`/api/endorsements/provider/${providerId}`, {
      params: { skip, limit },
    });
    return response.data;
  },

  // Update an endorsement
  update: async (endorsementId: number, data: EndorsementUpdate): Promise<Endorsement> => {
    const response = await api.put(`/api/endorsements/${endorsementId}`, data);
    return response.data;
  },

  // Accept a pending endorsement
  accept: async (endorsementId: number): Promise<{ message: string }> => {
    const response = await api.post(`/api/endorsements/${endorsementId}/accept`);
    return response.data;
  },

  // Reject a pending endorsement
  reject: async (endorsementId: number): Promise<{ message: string }> => {
    const response = await api.post(`/api/endorsements/${endorsementId}/reject`);
    return response.data;
  },

  // Remove an endorsement (soft delete)
  remove: async (endorsementId: number): Promise<{ message: string }> => {
    const response = await api.delete(`/api/endorsements/${endorsementId}`);
    return response.data;
  },

  // Get providers that the current user hasn't endorsed yet
  getProvidersToEndorse: async (skip = 0, limit = 20): Promise<ProviderPublic[]> => {
    const response = await api.get('/api/endorsements/providers-to-endorse', {
      params: { skip, limit },
    });
    return response.data;
  },
};
